import { Record } from 'immutable';
import { handleActions } from 'redux-actions';
import * as complaintsActions from './complaints-actions';

const initState = new Record({
  complaintsAPN: null,
})();

export const complaintsReducer = handleActions(
  {
    [complaintsActions.setComplaintsAPN]: (state, action) => {
      const { complaintsAPN } = action.payload;
      return state.set('complaintsAPN', complaintsAPN);
    },
  },
  initState
);
